import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";



const StackedBarChart = ({BarData, ColorData}) => {
  return (
    <>
      {/* <div className="graph">
        <div className="graph_heading">
          <h1 className="Graph_title">TOP SUPPLIES</h1>
          <OpenInNewIcon
            style={{ fontSize: "16", marginLeft: "5" }}
          ></OpenInNewIcon>
        </div>
      </div>
      <div className="graph_name G-name">
        <h5>Haryana</h5>
        <h5>Delhi</h5>
        <h5>Mumbai</h5>
      </div> */}
      <ResponsiveContainer aspect={3}>
        <BarChart
          width={500}
          height={300}
          data={BarData}
          margin={{
            top: 0,
            right: 50,
            left: 30,
            bottom: 15,
          }}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <XAxis dataKey="name" style={{ fontSize: "10" }} />
          {/* <YAxis style={{fontSize:"10"}}/> */}
          <Tooltip />
          <Legend />
          <Bar dataKey="pv" stackId="a" fill={ColorData[0].color} />
          <Bar dataKey="uv" stackId="a" fill={ColorData[1].color} />
          <Bar dataKey="cv" stackId="a" fill={ColorData[2].color} />
        </BarChart>
      </ResponsiveContainer>
    </>
  );
};

export default StackedBarChart;
